import React from "react";
import { createRoot } from "react-dom/client";
// scroll bar
import "simplebar/src/simplebar.css";

// third-party
import { Provider as ReduxProvider } from "react-redux";

// apex-chart
import "assets/third-party/apex-chart.css";
import "assets/style.css";

// project import
import App from "./App";
import { store, persistor } from "store";
import { PersistGate } from "redux-persist/integration/react";



// ==============================|| MAIN - REACT DOM RENDER  ||============================== //
const root = createRoot(document.getElementById("root"));
root.render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
